import { createClient, createConfig } from "reedy-data/api";
import { resolveEmulatorAddress, useEmulator } from "integrations/firebase/app";

import { AccountApi } from "./account";
import { ProductsApi } from "./products";
import { UsersApi } from "./users";
import { EvaluationApi } from "./evaluation";
import { BaseApi } from "./base";
import { FilesApi } from "./files";
import { ThemaApi } from "./thema";
import { BisacApi } from "./bisac";
import { ReportsApi } from "./reports";
import { BooksApi } from "./books";
import { ProjectsApi } from "./projects";

const resolveApiBaseUrl = (): string => {
  // If we run against local Firebase emulators, compute the URL at runtime
  if (useEmulator) {
    const { host, port } = resolveEmulatorAddress("functions");
    const projectId = import.meta.env.VITE_FIREBASE_PROJECT_ID;
    return `http://${host}:${port}/${projectId}/europe-west4/api`;
  }

  // Otherwise, fall back to explicitly configured URL
  const envUrl = import.meta.env.VITE_API_URL;
  return envUrl;
};

export const baseUrl = resolveApiBaseUrl();

export class Api extends BaseApi {
  account: AccountApi;

  products: ProductsApi;

  evaluation: EvaluationApi;

  users: UsersApi;

  files: FilesApi;

  thema: ThemaApi;

  bisac: BisacApi;

  reports: ReportsApi;

  books: BooksApi;

  projects: ProjectsApi;

  constructor() {
    const client = createClient(createConfig({ baseUrl }));

    super(client);

    this.account = new AccountApi(client);
    this.products = new ProductsApi(client);
    this.evaluation = new EvaluationApi(client);
    this.users = new UsersApi(client);
    this.files = new FilesApi(client);
    this.thema = new ThemaApi(client);
    this.bisac = new BisacApi(client);
    this.reports = new ReportsApi(client);
    this.books = new BooksApi(client);
    this.projects = new ProjectsApi(client);
  }

  setAuthToken(authToken?: string) {
    this.client.setConfig({
      auth: authToken,
    });
  }
}

export const api = new Api();
